module.exports = __webpack_public_path__ + "static/media/signage-indoor-img12.1e9ae3b2.jpg";